  <template>
    <div class="detail-module">
        <div class="remind-box" v-if="workNoType != 3 &&detail.sourceType == 96">
            客人为匿名评价，请勿联系客人!
        </div>
        <div class="detail-box">
            <div class="flex flex-y-center ">
                <img class="icon" src="../../../assets/img/head.png" alt="">
                <div class="module-title">
                    工单详情
                </div>
            </div>
            <div class="detail-inner flex flex-y-center flex-around">
                <div class="line flex flex-y-center line-l">
                    <div class="title">
                        接听人
                    </div>
                    <div class="txt">
                        {{detail.answer}}
                    </div>
                </div>
                <div class="line flex flex-y-center line-r">
                    <div class="title">
                        时间
                    </div>
                    <div class="txt">
                        {{detail.createTime}}
                    </div>
                </div>
            </div>
            <div class="detail-inner">
                <div class="line flex flex-y-center">
                    <div class="title">
                        工单来源
                    </div>
                    <div class="txt-l">
                        {{detail.sourceTypeStr}}
                    </div>
                </div>

            </div>
            <div class="detail-inner flex flex-y-center flex-around" v-if="workNoType == 3 ||detail.sourceType != 96">
                <div class="line flex flex-y-center line-l">
                    <div class="title">
                        反馈人
                    </div>
                    <div class="txt">
                        {{detail.feedback}}
                    </div>
                </div>
                <div class="line flex flex-y-center line-r">
                    <div class="title">
                        联系电话
                    </div>
                    <div class="txt">
                        {{detail.mobile}}
                    </div>
                </div>
            </div>
            <div class="detail-inner flex flex-y-center flex-around" v-if="workNoType == 3 ||detail.sourceType != 96">
                <div class="line flex flex-y-center line-l">
                    <div class="title">
                        卡号
                    </div>
                    <div class="txt">
                        {{detail.cardNo}}
                    </div>
                </div>
                <div class="line flex flex-y-center line-r">
                    <div class="title">
                        卡种
                    </div>
                    <div class="txt">
                        {{detail.cardType}}
                    </div>
                </div>
            </div>
            <div class="detail-inner" v-if="workNoType == 3 ||detail.sourceType != 96">
                <div class="line flex flex-y-center line-l">
                    <div class="title">
                        会籍门店
                    </div>
                    <div class="txt-l">
                        {{detail.cardStore}}
                    </div>
                </div>
            </div>
            <div class="detail-inner">
                <div class="line flex flex-y-center line-r">
                    <div class="title">
                        反馈门店
                    </div>
                    <div class="txt-l">
                        {{detail.feedbackStore}}
                    </div>
                </div>
            </div>
            <div class="detail-inner">
                <div class="line flex flex-y-center">
                    <div class="title">
                        反馈种类
                    </div>
                    <div class="txt-l">
                        {{detail.feedbackType}}
                    </div>
                </div>
            </div>
        </div>
        <div class="feedback-box">
            <div class="flex flex-y-center ">
                <img class="icon" src="../../../assets/img/edit.png" alt="">
                <div class="module-title" v-if="workNoType == 2">
                    投诉内容
                </div>
                <div class="module-title" v-else>
                    反馈内容
                </div>
            </div>
            <div class="msg">
                {{detail.feedbackContent}}
            </div>
        </div>
        <div class="appeal-box">
            <div class="flex flex-y-center ">
                <img class="icon" src="../../../assets/img/edit.png" alt="">
                <div class="module-title">
                    顾客诉求
                </div>
            </div>
            <div class="msg">
                {{detail.appeal}}
            </div>
        </div>
        <div class="appeal-box">
            <div class="flex flex-y-center ">
                <img class="icon" src="../../../assets/img/edit.png" alt="">
                <div class="module-title">
                    顾客诉求补充说明
                </div>
            </div>
            <div class="msg">
                {{detail.remark}}
            </div>
        </div>
        <div class="appeal-box" v-if="rollbackDTOList.length != 0">
            <div class="flex flex-y-center ">
                <img class="icon" src="../../../assets/img/edit.png" alt="">
                <div class="module-title">
                    退回原因
                </div>
            </div>
            <div class="roll-back-box" v-for="item,index in detail.rollbackDTOList" :key="index">
                <div class="roll-back-title">
                    第{{index+1}}次退回
                </div>
                <div class="roll-back-msg">审核人：<span class="msg">{{item.name}}</span></div>
                <div class="roll-back-msg">退回理由：<span class="msg">{{item.reason}}</span></div>
            </div>
        </div>
        <div class="follow-box">
            <div class="flex flex-y-center ">
                <img class="icon" src="../../../assets/img/edit.png" alt="">
                <div class="module-title">
                    跟进处理<span class="title-tag" v-if="rollbackDTOList.length != 0">（请重新填写并提交）</span>
                </div>
            </div>
            <div class="input-line flex flex-y-center mb-56">
                <div class="msg-tit">调查过程</div>
                <textarea v-model="detail.course" row="1" class="input" placeholder='请输入' placeholder-style="color:#A0ACB5"
                    auto-height="true" resize="vertical" v-if="!isOver" @input="handleInput">
                </textarea>
                <div v-else class="flex-1 black">{{detail.course}}</div>

            </div>
            <div class="input-line flex flex-y-center mb-56">
                <div class="msg-tit">处理结果</div>
                <textarea v-model="detail.result" class="input" placeholder='请输入' placeholder-style="color:#A0ACB5"
                    auto-height="true" v-if="!isOver" @input="handleInput">
                </textarea>
                <div v-else class="flex-1 black">{{detail.result}}</div>

            </div>
            <div class="input-line flex flex-y-center mb-56">
                <div class="msg-tit">改进措施</div>
                <textarea v-model="detail.measure" class="input" placeholder='请输入' placeholder-style="color:#A0ACB5"
                    auto-height="true" v-if="!isOver" @input="handleInput">
                </textarea>
                <div v-else class="flex-1 black">{{detail.measure}}</div>

            </div>
            <div class="input-line flex flex-y-center mb-56" @click="showTimePopup">
                <div class="msg-tit">完成时间</div>
                <input v-model="newDate" auto-height="true" class="input" readonly="readonly" placeholder="请选择改进措施完成时间"
                    placeholder-style="color:#A0ACB5" v-if="!isOver">
                <van-icon class="arrow" name="arrow" color="#a0acb5" v-if="!isOver" />
                <div v-else class="flex-1 black">{{detail.newDate}}</div>

            </div>
            <div v-if="!isOver" class="btn-box flex flex-y-center flex-around">
                <div class="staging-btn" @click="saveClick">
                    保存
                </div>
                <div class="over-btn" @click="overCase">
                    提交
                </div>
            </div>
        </div>
        <!-- 时间选择器 -->
        <van-popup v-model="showTime " position="bottom" custom-style="height: 40%;" @click-overlay="closeTimePopup">
            <van-datetime-picker type="date" v-model="currentDate" :min-date="minDate" :max-date="maxDate" :formatter="formatter"
                @confirm="onTimeConfirm" @cancel="onTimeCancel" />
        </van-popup>
        <van-loading v-show="isLoading" />
        <van-overlay :show="isLoading" />
    </div>
</template>

  <script>
import request from "@/utils/request";
import { Toast } from 'vant'
import { timeFormat } from "@/utils";


export default {
    name: "repairOrderDetail",
    data() {
        return {
            guidKey: null,
            isOver: false, //是否结案
            detail: {}, //详情
            currentDate: new Date(),
            minDate: new Date(1940, 0, 1), // 最小可选
            maxDate: new Date(), // 最大可选
            formatter(type, value) {
                if (type === "year") {
                    return `${value}年`;
                }
                if (type === "month") {
                    return `${value}月`;
                }
                return value;
            },
            showTime: false,
            workNoType: 1, //分类:2 投诉 1 反馈/建议
            course: "", //调查过程
            measure: "", //改进措施
            result: "", //处理结果
            newDate: "", //	完成时间
            guid: "",
            store: "",
            workNo: "",
            classify: "",
            isLoading: true,
            rollbackDTOList: []

        };
    },
    mounted() {
        this.guidKey = `repair-detail-${this.$route.query.guid}`
        this.workNoType = this.$route.query.workNoTypeId
        this.guid = this.$route.query.guid
        this.store = this.$route.query.storeNo
        this.workNo = this.$route.query.workNo
        this.getDetail();
        if (this.workNoType == 3) {
            document.title = '投诉工单详情'
        } else {
            document.title = '反馈工单详情'
        }
    },
    methods: {
        // 详情
        getDetail() {
            return request({
                url: `/work/workNoDetail?guid=${this.guid}&storeNo=${this.store}&workNo=${this.workNo}`,
                method: "get",
            }).then((res) => {
                this.isLoading = false
                const resData = res.data;
                this.classify = resData.classify
                // 判断是否结案
                if (resData.status == false) {
                    this.isOver = true
                    this.detail = resData
                    this.newDate = resData.newDate
                } else {
                    let inputData = localStorage.getItem(this.guidKey);
                    inputData = inputData ? JSON.parse(inputData) : {};
                    this.isOver = false
                    this.detail = { ...resData, ...inputData }
                    this.rollbackDTOList = this.detail.rollbackDTOList
                    this.newDate = inputData.newDate
                    if (this.newDate != undefined) {
                        this.currentDate = new Date(this.newDate.replace(/-/g, "/"))
                    }
                }
            }).catch((error) => {
                Toast({ position: 'top', message: error ?? '' })
            })
        },
        // 结案
        overCase() {
            return new Promise((resolve) => {
                if (!this.detail.course || !this.detail.measure || !this.detail.result || !this.newDate) {
                    return Toast({ position: 'top', message: '请填写处理内容' })
                }
                let params = {
                    course: this.detail.course,
                    measure: this.detail.measure,
                    result: this.detail.result,
                    newDate: this.newDate,
                    guid: this.guid,
                    storeNo: this.store,
                    classify: this.classify
                };
                return request({
                    url: `/work/updateWorkNo`,
                    method: "put",
                    data: params
                }).then((res) => {
                    Toast({ position: 'top', message: '结案成功' })
                    this.$router.go(-1)
                }).catch((error) => {
                    Toast({ position: 'top', message: error ?? '' })
                })
            });
        },
        // 暂存
        saveClick() {
            const { detail, guidKey, newDate } = this;
            const data = { ...detail, newDate }
            if (!detail.course || !detail.measure || !detail.result || !newDate) {
                return Toast({ position: 'top', message: '请填写处理内容' })
            }
            localStorage.setItem(guidKey, JSON.stringify(data));
            // this.$router.go(-1)
            Toast({ position: 'top', message: '保存成功' })

        },
        // 时间选择
        showTimePopup() {
            this.showTime = true

        },
        closeTimePopup() {
            this.showTime = false
        },
        onTimeCancel() {
            this.showTime = false
        },
        onTimeConfirm(event) {
            this.showTime = false
            this.newDate = timeFormat(event.getTime())
        },
        handleInput(e) {
            e.target.style.height = 'auto';
            e.target.style.height = e.target.scrollHeight + 'px';

        }


    },
};
</script>

<style scoped lang="less">
input[disabled],
input:disabled,
input.disabled {
    color: #2a2a2a;
    -webkit-text-fill-color: #2a2a2a;
    -webkit-opacity: 1;
    opacity: 1;
}
.van-loading {
    position: fixed !important;
    top: 50%;
    left: 50%;
    transform: translateX(-50%);
    z-index: 99;
}
.icon {
    width: 40px;
    height: 40px;
    vertical-align: middle;
    margin-right: 20px;
}
.detail-module {
    height: 100%;
    overflow-y: auto;
    background-color: #f9fafc;
}
.module-title {
    font-weight: bold;
    font-size: 34px;
    .title-tag {
        font-weight: 700;
        font-size: 28px;
        color: #35434c;
    }
}
.remind-box {
    background-color: #fff;
    font-size: 28px;
    font-weight: 400;
    color: #f65252;
    text-align: center;
    padding-top: 30px;
}
.detail-box {
    /* height: 713px; */
    padding: 30px 30px 50px 30px;
    background-color: #fff;
    box-sizing: content-box !important;
}

.detail-inner {
    padding-top: 50px;
}

.detail-inner > .line {
    /* flex: 1; */
    min-width: 0;
}

.line-l {
    width: 320px;
}

.line-r {
    flex: 1;
}

.line .title {
    color: #a0acb5;
    margin-right: 20px;
    min-width: 40px;
    font-size: 28px;
}

.line .txt {
    color: #35434c;
    /* width: 240px; */
    flex: 1;
    font-size: 28px;
}

.line .txt-l {
    color: #35434c;
    /* max-width: 220px;
   */
    flex: 1;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    font-size: 28px;
}

.feedback-box {
    padding: 50px 30px;
    min-height: 278px;
    background-color: #fff;
    margin-top: 20px;
}

.msg {
    margin-top: 50px;
    color: #35434c;
    font-size: 28px;
    word-break: break-all;
}

.appeal-box {
    padding: 50px 30px;
    min-height: 238px;
    background-color: #fff;
    margin-top: 20px;
}
.roll-back-box {
    padding-top: 10px;
    .roll-back-title {
        font-weight: 700;
        font-size: 28px;
        color: #35434c;
        margin-top: 40px;
    }
    .roll-back-msg {
        font-weight: 400;
        font-size: 28px;
        color: #a0acb5;
        margin-top: 30px;
    }
}
.follow-box {
    padding: 50px 30px;
    min-height: 806px;
    background-color: #fff;
    margin-top: 20px;
}

.input-line {
    position: relative;
    margin-top: 50px;
    font-size: 28px;
}
.input {
    width: 492px;
    border-radius: 6px;
    border: 1px solid #999999;
    padding: 16px 30px;
}
textarea[resize="vertical"] {
    resize: vertical;
}
.circle {
    width: 16px;
    height: 16px;
    border-radius: 50%;
    margin-right: 22px;
    background: #d8d8d8;
}

.circle.already {
    background: #333f48;
}

.msg-tit {
    min-width: 158px;
    font-size: 28px;
    color: #a0acb5;
}
.msg-tit::before {
    content: "*";
    color: #e54d42;
}
.black {
    color: #35434c;
    word-break: break-all;
}

.arrow {
    position: absolute;
    right: 50px;
    top: 22px;
    width: 16px;
    height: 28px;
}

.btn-box {
    margin-top: 80px;
}

.staging-btn {
    width: 250px;
    height: 90px;
    background: #333f48;
    border-radius: 45px;
    line-height: 90px;
    text-align: center;
    color: #fff;
    font-size: 30px;
}

.over-btn {
    width: 250px;
    height: 90px;
    background: #2fd0d5;
    border-radius: 45px;
    line-height: 90px;
    text-align: center;
    color: #fff;
    font-size: 30px;
}
</style>


